import {HttpClient} from '@angular/common/http';
import {PathService} from '../../login/services/path.service';
import {Injectable} from '@angular/core';
import {Observable} from 'rxjs';
import {PartnerDtoModel} from '../models/partner.dto.model';
import {PaginationArgs} from '../models/pagination.args';

@Injectable({
    providedIn: 'root'
})
export class PartenaireService {

    private baseUrl = '';

    constructor(protected http: HttpClient, private pathService: PathService) {
        this.baseUrl = `${pathService.hostServerBackOffice}/partner`;
    }

    public findAllPartenaires(nameToSearch: string, paginationArgs: PaginationArgs): Observable<PartnerDtoModel[]> {
        return this.http.get<PartnerDtoModel[]>(`${this.baseUrl}?page=${paginationArgs.pageNumber}&size=${paginationArgs.pageSize}&filterName=${nameToSearch}`);
    }

    public getPartnerByUuid(uuid: string): Observable<PartnerDtoModel> {
        return this.http.get<PartnerDtoModel>(`${this.baseUrl}` + '/uuid/' + uuid);
    }

    public addNewPartner(partner: any): Observable<void> {
        return this.http.post<void>(`${this.baseUrl}`, partner);
    }

    public updatePartner(partner: any): Observable<void> {
        return this.http.put<void>(`${this.baseUrl}`, partner);
    }

    public deletePartner(uuid: string): Observable<void> {
        return this.http.delete<void>(`${this.baseUrl}/${uuid}`);
    }
}
